module.exports = __webpack_public_path__ + "static/circularstd-medium-a5ae33f65d65a022b10923d72174a279.woff";